import { render, staticRenderFns } from "./TermsConditions.vue?vue&type=template&id=f0031a84&scoped=true&"
import script from "./TermsConditions.vue?vue&type=script&lang=js&"
export * from "./TermsConditions.vue?vue&type=script&lang=js&"
import style0 from "./TermsConditions.vue?vue&type=style&index=0&id=f0031a84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0031a84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0031a84')) {
      api.createRecord('f0031a84', component.options)
    } else {
      api.reload('f0031a84', component.options)
    }
    module.hot.accept("./TermsConditions.vue?vue&type=template&id=f0031a84&scoped=true&", function () {
      api.rerender('f0031a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/TermsConditions.vue"
export default component.exports